<template>
    <v-menu
        min-width="180"
        offset-y
        bottom
        left
        nudge-bottom="14"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            text
            class="primary--text"
        >
          <p class="d-none d-sm-flex mb-0 text-capitalize primary--text">
            {{ $t('navbar:settingsLinks.title') }}
          </p>
          <v-icon small class="ml-1 d-none d-sm-block">expand_more</v-icon>
          <v-icon class="d-sm-none">settings</v-icon>
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{ user.name }}</div>
        <v-list-item-group color="primary">
          <v-list-item
              v-for="item in checkIsMain(account)"
              :key="item.text"
              router
              :to="item.route"
          >
            <v-list-item-icon class="mr-4">
              <v-icon
                  :color="item.color"
                  v-text="item.icon"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title color="greyTint">{{
                  $t('navbar:settingsLinks.' + item.text)
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <div class="d-flex justify-center my-3">
          <v-btn
              width="80%"
              large
              outlined
              color="primary"
              class="text-capitalize"
              @click.prevent="logout"
          >
            {{ $t('navbar:settingsLinks.logout') }}
          </v-btn>
        </div>
      </v-list>
    </v-menu>
</template>

<script>

import {mapActions} from 'vuex';
import {Role} from "@/modules/core/data/roles";

export default {
    name: "UserMenu",
    props: {
        user: {}
    },
    data: function() {
        return {
            account: [
                {text: 'settings', icon: 'settings', color: 'greyTint', route: `/${this.$store.state.manager.settingsModuleUrl}/profile/user`, main: false}
            ],
        }
    },
    computed: {
        // Own
        currentUser() {
            return this.$store.state.auth.user;
        },
        isAdmin() {
            if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes(Role.Admin);
            }
            return false;
        },
        isMain() {
            if (this.currentUser) {
                return this.currentUser.main;
            }
            return false;
        }
    },
    methods: {
        ...mapActions('auth', ['logoutUser']),
        checkIsMain: function (links) {
            var self = this;
            return links.filter(function (link) {
                return !link.main || (link.main && self.isMain)
            })
        },
        logout() {
            this.$store.dispatch('auth/logout');
        },
    }
}
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>
